import { render, staticRenderFns } from "./LoanDetails.vue?vue&type=template&id=dac219f6"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"
import style0 from "./LoanDetails.vue?vue&type=style&index=0&id=dac219f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports